<!doctype html>
<html lang="en">

	<head>

		<meta name="csrf-param" content="authenticity_token">
		<meta name="csrf-token"
			content="cutJwcUCXW+hQK1GCe56qDBnHD4klNEGunT5WMdxrWVCq9kfX93tsjmnP4pAwzvJBh2Y2sSw/eVG6mqgA8XPsg==">

		<title>

			Inbound Pixels

		</title>
		<meta charset="utf-8" />
		<meta http-equiv="x-ua-compatible" content="ie=edge, chrome=1">
		<meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">

		<meta property="og:type" content="website">
		<meta property="og:url" content="https://www.inboundpixels.com/">
		<meta name="twitter:card" content="summary_large_image">

		<meta property="og:title" content="Inbound Pixels">
		<meta name="twitter:title" content="Inbound Pixels">





		<link
			href="https://kajabi-storefronts-production.global.ssl.fastly.net/kajabi-storefronts-production/themes/2147493283/settings_images/aqYqNZ3TS2iSvc9jc0Ea_favicon.ico.png?v=2"
			rel="shortcut icon" />

		<link rel="canonical" href="https://www.inboundpixels.com/" />

		<!-- Google Fonts ====================================================== -->

		<link
			href="//fonts.googleapis.com/css?family=Open+Sans:400,700,400italic,700italic|Fira+Sans:400,700,400italic,700italic"
			rel="stylesheet" type="text/css">


		<!-- Kajabi CSS ======================================================== -->
		<link rel="stylesheet" media="screen"
			href="https://kajabi-app-assets.global.ssl.fastly.net/assets/core-f726e70c2cc061a3a1328f0d0554ca2db2ae685b27b368b07c3c6d5d819e1c8b.css" />



		<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.15.2/css/all.css" crossorigin="anonymous">

		<link rel="stylesheet" media="screen"
			href="https://kajabi-storefronts-production.global.ssl.fastly.net/kajabi-storefronts-production/themes/2147493283/assets/styles.css?1615935203353986" />

		<!-- Customer CSS ====================================================== -->
		<link rel="stylesheet" media="screen"
			href="https://kajabi-storefronts-production.global.ssl.fastly.net/kajabi-storefronts-production/themes/2147493283/assets/overrides.css?1615935203353986" />
		<style>
			/* Custom CSS Added Via Theme Settings */
			@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap');

			h1,
			h2,
			h3,
			h4,
			h5,
			h6,
			p,
			body,
			html,
			a,
			.btn {
				font-family: 'Inter', sans-serif;
			}

			h1,
			h2,
			h3,
			he,
			h5,
			h6 {
				font-weight: 900;
			}
		</style>


		<!-- Kajabi Editor Only CSS ============================================ -->


		<!-- Header hook ======================================================= -->
		
		<style type="text/css">
			#editor-overlay {
				display: none;
				border-color: #2E91FC;
				position: absolute;
				background-color: rgba(46, 145, 252, 0.05);
				border-style: dashed;
				border-width: 3px;
				border-radius: 3px;
				pointer-events: none;
				cursor: pointer;
				z-index: 10000000000;
			}

			.editor-overlay-button {
				color: white;
				background: #2E91FC;
				border-radius: 2px;
				font-size: 13px;
				margin-left: -24px;
				margin-top: -12px;
				padding: 3px 10px;
				text-transform: uppercase;
				font-weight: bold;
				letter-spacing: 1.5px;

				left: 50%;
				top: 50%;
				position: absolute;
			}
		</style>
		

	</head>

	<style>
	</style>

	<body class="background-unrecognized">



		<div id="section-header" data-section-id="header">
			<style>
				.header {

					background-color: #FFFFFF;

					font-size: 16px;
				}

				.header--fixed {
					background: #FFFFFF;
				}

				@media (min-width: 768px) {
					.header {
						font-size: 18px;
					}
				}

				@media (max-width: 767px) {

					.header a.link-list__link,
					.dropdown__item a {
						text-align: left;
					}

					.header--overlay .header__content--mobile {
						padding-bottom: 20px;
					}

					.header__content--mobile {
						text-align: left;
					}
				}
			</style>

			<div class="hidden">






			</div>

			<header class="header header--static    header--close-on-scroll"
				kjb-settings-id="sections_header_settings_background_color">
				<div class="hello-bars">



				</div>

				<div class="header__wrap">
					<div class="header__content header__content--desktop background-unrecognized">
						<div class="container header__container media justify-content-left">


							<style>
								@media (min-width: 768px) {
									#block-1555988494486 {
										text-align: left;
									}
								}
							</style>

							<div id="block-1555988494486"
								class="header__block header__block--logo header__block--show header__switch-content "
								kjb-settings-id="sections_header_blocks_1555988494486_settings_stretch">
								<style>
									#block-1555988494486 {
										line-height: 1;
									}

									#block-1555988494486 .logo__image {
										display: block;
										width: 220px;
									}

								</style>


							</div>




						</div>
					</div>
					<div class="header__content header__content--mobile">
						<div class="header__switch-content header__spacer"></div>
					</div>
				</div>

			</header>

		</div>
		<main>
			<div data-content-for-index data-dynamic-sections="index">
				<div id="section-1615850975510" data-section-id="1615850975510">
					<style>
						#section-1615850975510 .section {
							background-color: #ffffff;
						}

						#section-1615850975510 .sizer {
							padding-top: 40px;
							padding-bottom: 40px;
						}

						#section-1615850975510 .container {
							max-width: calc(1260px + 10px + 10px);
							padding-right: 10px;
							padding-left: 10px;

						}


						#section-1615850975510 .container--full {
							max-width: calc(100% + 10px + 10px);
						}

						@media (min-width: 768px) {

							#section-1615850975510 .sizer {
								padding-bottom: 100px;
							}

							#section-1615850975510 .container {
								max-width: calc(1260px + 40px + 40px);
								padding-right: 40px;
								padding-left: 40px;
							}

							#section-1615850975510 .container--full {
								max-width: calc(100% + 40px + 40px);
							}
						}
					</style>


					<section kjb-settings-id="sections_1615850975510_settings_background_color" class="section
  
  
   background-light " data-reveal-event="" data-reveal-offset="" data-reveal-units="seconds">
						<div class="sizer ">

							<div class="container ">
								<div class="row align-items-start justify-content-center">

									<!-- removes default padding from card elements -->

									<!-- removes default padding when box-shadow is enabled -->

									<!-- default padding values -->



									<style>
										/* flush setting */

										/* margin settings */
										#block-1615851008851 {
											margin-top: 0px;
											margin-right: 0px;
											margin-bottom: 0px;
											margin-left: 0px;
										}

										#block-1615851008851 .block {
											/* border settings */
											border: 4px none black;
											border-radius: 4px;
											/* background color */

											/* default padding for mobile */



											/* mobile padding overrides */

											padding: 0;





										}

										@media (min-width: 768px) {

											/* desktop margin settings */
											#block-1615851008851 {
												margin-top: 0px;
												margin-right: 0px;
												margin-bottom: 0px;
												margin-left: 0px;
											}

											#block-1615851008851 .block {
												/* default padding for desktop  */


												/* desktop padding overrides */

												padding: 0;


												padding-top: 10px;


												padding-right: 24px;



											}
										}

										/* mobile text align */
										@media (max-width: 767px) {
											
										}
									</style>



									<div kjb-settings-id="sections_1615850975510_blocks_1615851008851_settings_width" style="min-width: 360px;"
										id="block-1615851008851" class="
  block-type--image
  text-
  col-6
  " data-reveal-event="" data-reveal-offset="" data-reveal-units="seconds">
										<div class="block
    box-shadow-none
    " data-aos="none" data-aos-delay="0" data-aos-duration="0">

											<style>
												#block-1615851008851 .block {
													display: flex;
													justify-content: flex-start;
												}

												#block-1615851008851 .image {
													width: 100%;

												}

												#block-1615851008851 .image__image {
													width: 100%;

												}

												#block-1615851008851 .image__overlay {

													opacity: 0;

													background-color: #fff;
												}

												@media (min-width: 768px) {
													#block-1615851008851 .block {
														display: flex;
														justify-content: flex-start;
														
													}

													#block-1615851008851 .image__overlay {
														opacity: 0;
													}

													#block-1615851008851 .image__overlay:hover {
														opacity: 1;
													}
												}
											</style>

											<div class="image" >


												<img class="image__image" 
													src="https://i.ibb.co/F06m0c3/e6bc2944-44bd-4095-823e-e0c009d417d9.jpg"
													kjb-settings-id="sections_1615850975510_blocks_1615851008851_settings_image"
													alt="" />



											</div>

										</div>
									</div>



									<!-- removes default padding from card elements -->

									<!-- removes default padding when box-shadow is enabled -->

									<!-- default padding values -->



									<style>
										/* flush setting */

										/* margin settings */
										#block-1615850975510_1 {
											margin-top: 0px;
											margin-right: 0px;
											margin-bottom: 0px;
											margin-left: 0px;
										}

										#block-1615850975510_1 .block {
											/* border settings */
											border: 4px none black;
											border-radius: 4px;
											/* background color */

											background-color: #fff;

											/* default padding for mobile */

											padding: 20px;



											/* mobile padding overrides */


											padding-top: 20px;


											padding-right: 20px;


											padding-bottom: 20px;


											padding-left: 20px;

										}

										@media (min-width: 768px) {

											/* desktop margin settings */
											#block-1615850975510_1 {
												margin-top: 0px;
												margin-right: 0px;
												margin-bottom: 0px;
												margin-left: 0px;
											}

											#block-1615850975510_1 .block {
												/* default padding for desktop  */

												padding: 30px;


												/* desktop padding overrides */


												padding-top: 0px;


												padding-right: 0px;


												padding-bottom: 0px;


												padding-left: 0px;

											}
										}

										/* mobile text align */
										@media (max-width: 767px) {
											#block-1615850975510_1 {
												text-align: center;
											}
										}
									</style>



									<div kjb-settings-id="sections_1615850975510_blocks_1615850975510_1_settings_width"
										id="block-1615850975510_1" class=" block-type--form  text-left  col-6 " data-reveal-event="" data-reveal-offset="" data-reveal-units="seconds" style="min-width: 400px;">
										<div class="block
    box-shadow-none
     background-light" data-aos="none" data-aos-delay="0" data-aos-duration="0">
											<style>
												#block-1615850975510_1 .form-btn {
													border-color: #f50057;
													border-radius: 12px;
													background: #f50057;
													color: #ffffff;
												}

												#block-1615850975510_1 .btn--outline {
													color: #f50057;
													background: transparent;
												}

												#block-1615850975510_1 .disclaimer-text {
													font-size: 16px;
													margin-top: 1.25rem;
													margin-bottom: 0;
													color: #888;
												}
											</style>



											<div class="form">
												<div
													kjb-settings-id="sections_1615850975510_blocks_1615850975510_1_settings_text">
													<h1></h1>
													<h1>Submit Query Form and get to know yourself</h1>

													<form data-parsley-validate="true" data-kjb-disable-on-submit="true"
														action="https://www.inboundpixels.com/forms/2147484940/form_submissions"
														accept-charset="UTF-8" method="post"><input name="utf8"
															type="hidden" value="&#x2713;" /><input type="hidden"
															name="authenticity_token"
															value="cutJwcUCXW+hQK1GCe56qDBnHD4klNEGunT5WMdxrWVCq9kfX93tsjmnP4pAwzvJBh2Y2sSw/eVG6mqgA8XPsg==" /><input
															type="text" name="website_url" autofill="off"
															placeholder="Skip this field"
															style="display: none;" /><input type="hidden"
															name="kjb_fk_checksum" autofill="off"
															value="2dfeee0f824e7ba1083eb6ecad58fbed" />
														<div class="">
															<input type="hidden" name="thank_you_url" value="">

															<div class="email-field form-group">
																<input
                                                                    required="required" class="form-control"
																	placeholder="Name" type="text" #textbox="ngModel"
                                                                    [(ngModel)]="nam" data-parsley-remote="true"
                                                                    name="textbox" id="form_submission_email"
																	/>
																<input
                                                                    required="required" class="form-control"
																	placeholder="Email" type="text" #textbox="ngModel"
                                                                    [(ngModel)]="email" data-parsley-remote="true"
                                                                    name="textbox" id="form_submission_email"
																	/>
                                                                <input
                                                                    required="required" class="form-control"
																	placeholder="Phone number" type="text" #textbox="ngModel"
                                                                    [(ngModel)]="phone" data-parsley-remote="true"
                                                                    name="textbox" id="form_submission_email"
																	/>
																</div>

															<button id="form-button"
																class="form-btn btn--solid btn--auto btn--large"
																type="submit" (click)="e()"
																kjb-settings-id="sections_1615850975510_blocks_1615850975510_1_settings_btn_text">
																Get to know yourself
															</button>
														</div>
													</form>


												</div>

											</div>
										</div>



									</div>
								</div>
							</div>
						</div>
					</section>
				</div>
				<div id="section-1615856956840" data-section-id="1615856956840">
					<style>

						#section-1615856956840 .sizer {
							padding-top: 40px;
							padding-bottom: 40px;
						}

						#section-1615856956840 .container {
							max-width: calc(1260px + 10px + 10px);
							padding-right: 10px;
							padding-left: 10px;

						}
						#section-1615856956840 .container--full {
							max-width: calc(100% + 10px + 10px);
						}

						@media (min-width: 768px) {

							#section-1615856956840 .sizer {
								padding-top: 0px;
								padding-bottom: 100px;
							}

							#section-1615856956840 .container {
								max-width: calc(1260px + 40px + 40px);
								padding-right: 40px;
								padding-left: 40px;
							}

							#section-1615856956840 .container--full {
								max-width: calc(100% + 40px + 40px);
							}
						}
					</style>


					<section kjb-settings-id="sections_1615856956840_settings_background_color" class="section
  
  
   " data-reveal-event="" data-reveal-offset="" data-reveal-units="seconds">
						<div class="sizer" style="background-attachment: fixed ;background-size:cover; background-repeat:no-repeat; background-image: linear-gradient(to top, rgba(255,255,255,0.65),rgba(255,255,255,0.65)),url(data:image/jpeg;base64,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);">

							<div class="container ">
								<div class="row align-items-center justify-content-center">

									<!-- removes default padding from card elements -->

									<!-- removes default padding when box-shadow is enabled -->

									<!-- default padding values -->



									<style>
										/* flush setting */

										/* margin settings */
										#block-1615856967837 {
											margin-top: 0px;
											margin-right: 0px;
											margin-bottom: 0px;
											margin-left: 0px;
										}

										#block-1615856967837 .block {
											/* border settings */
											border: 4px none black;
											border-radius: 4px;
											/* background color */

											/* default padding for mobile */



											/* mobile padding overrides */





										}

										@media (min-width: 768px) {

											/* desktop margin settings */
											#block-1615856967837 {
												margin-top: 0px;
												margin-right: 0px;
												margin-bottom: 100px;
												margin-left: 0px;
											}
										}

										/* mobile text align */
										@media (max-width: 767px) {
											#block-1615856967837 {
												text-align: left;
											}
										}
									</style>



									<div kjb-settings-id="sections_1615856956840_blocks_1615856967837_settings_width"
										id="block-1615856967837" class="
  block-type--text
  text-left
  col-12
  
  
  
    
  
  " data-reveal-event="" data-reveal-offset="" data-reveal-units="seconds">
										<div class="block
    box-shadow-none
    " data-aos="none" data-aos-delay="0" data-aos-duration="0">

											<style>
												#block-1577982541036_0 .btn {
													margin-top: 1rem;
												}
											</style>

											<h2>You are not alone</h2>
											<div style="color:black; font-weight: 500;">How to recover mental health challenges  || 
How mental health impact your physical & clinical life  || 
What are the mental health recovery process
											</div>

										</div>
									</div>



									<!-- removes default padding from card elements -->

									<!-- removes default padding when box-shadow is enabled -->

									<!-- default padding values -->



									<style>
										/* flush setting */

										/* margin settings */
										#block-1615857203175 {
											margin-top: 0px;
											margin-right: 0px;
											margin-bottom: 0px;
											margin-left: 0px;
										}

										#block-1615857203175 .block {
											/* border settings */
											border: 4px none black;
											border-radius: 4px;
											/* background color */

											/* default padding for mobile */





											/* mobile padding overrides */

											padding: 0;





										}

										@media (min-width: 768px) {

											/* desktop margin settings */
											#block-1615857203175 {
												margin-top: 0px;
												margin-right: 0px;
												margin-bottom: 0px;
												margin-left: 0px;
											}

											#block-1615857203175 .block {
												/* default padding for desktop  */




												/* desktop padding overrides */

												padding: 0;





											}
										}

										/* mobile text align */
										@media (max-width: 767px) {
											
										}
									</style>



									<div kjb-settings-id="sections_1615856956840_blocks_1615857203175_settings_width"
										id="block-1615857203175" class="
  block-type--image
  text-
  col-4
  
  
  
    
  
  " data-reveal-event="" data-reveal-offset="" data-reveal-units="seconds">
										<div class="block
    box-shadow-small
    " data-aos="none" data-aos-delay="0" data-aos-duration="0">

											<style>
												.image{
													text-align:center;
												}
												#block-1615857203175 .block {
													display: flex;
													justify-content: flex-start;
												}

												#block-1615857203175 .image {
													width: 100%;

												}

												#block-1615857203175 .image__image {
													width: 100%;

												}

												#block-1615857203175 .image__overlay {

													opacity: 0;

													background-color: #fff;
												}

												@media (min-width: 768px) {
													#block-1615857203175 .block {
														display: flex;
														justify-content: flex-start;
													}

													#block-1615857203175 .image__overlay {
														opacity: 0;
													}

													#block-1615857203175 .image__overlay:hover {
														opacity: 1;
													}
												}
											</style>

											<div class="image">

												<a>
													<h4>Free Personality assessment.</h4>

												</a>



											</div>

										</div>
									</div>



									<!-- removes default padding from card elements -->

									<!-- removes default padding when box-shadow is enabled -->

									<!-- default padding values -->



									<style>
										/* flush setting */

										/* margin settings */
										#block-1615857282726 {
											margin-top: 0px;
											margin-right: 0px;
											margin-bottom: 0px;
											margin-left: 0px;
										}

										#block-1615857282726 .block {
											/* border settings */
											border: 4px none black;
											border-radius: 4px;
											/* background color */

											/* default padding for mobile */





											/* mobile padding overrides */

											padding: 0;





										}

										@media (min-width: 768px) {

											/* desktop margin settings */
											#block-1615857282726 {
												margin-top: 0px;
												margin-right: 0px;
												margin-bottom: 0px;
												margin-left: 0px;
											}

											#block-1615857282726 .block {
												/* default padding for desktop  */




												/* desktop padding overrides */

												padding: 0;





											}
										}

										/* mobile text align */
										@media (max-width: 767px) {
											
										}
									</style>



									<div kjb-settings-id="sections_1615856956840_blocks_1615857282726_settings_width"
										id="block-1615857282726" class="
  block-type--image
  text-
  col-4
  
  
  
    
  
  " data-reveal-event="" data-reveal-offset="" data-reveal-units="seconds">
										<div class="block
    box-shadow-small
    " data-aos="none" data-aos-delay="0" data-aos-duration="0">

											<style>
												#block-1615857282726 .block {
													display: flex;
													justify-content: flex-start;
												}

												#block-1615857282726 .image {
													width: 100%;

												}

												#block-1615857282726 .image__image {
													width: 100%;

												}

												#block-1615857282726 .image__overlay {

													opacity: 0;

													background-color: #fff;
												}


												@media (min-width: 768px) {
													#block-1615857282726 .block {
														display: flex;
														justify-content: flex-start;
													}

													#block-1615857282726 .image__overlay {
														opacity: 0;
													}

													#block-1615857282726 .image__overlay:hover {
														opacity: 1;
													}
												}
											</style>

											<div class="image">
												<a>
												<h4>Free pressure level check over your head </h4>

												</a>



											</div>

										</div>
									</div>



									<!-- removes default padding from card elements -->

									<!-- removes default padding when box-shadow is enabled -->

									<!-- default padding values -->



									<style>
										/* flush setting */

										/* margin settings */
										#block-1615857321001 {
											margin-top: 0px;
											margin-right: 0px;
											margin-bottom: 0px;
											margin-left: 0px;
										}

										#block-1615857321001 .block {
											/* border settings */
											border: 4px none black;
											border-radius: 4px;
											/* background color */

											/* default padding for mobile */





											/* mobile padding overrides */

											padding: 0;





										}

										@media (min-width: 768px) {

											/* desktop margin settings */
											#block-1615857321001 {
												margin-top: 0px;
												margin-right: 0px;
												margin-bottom: 0px;
												margin-left: 0px;
											}

											#block-1615857321001 .block {
												/* default padding for desktop  */




												/* desktop padding overrides */

												padding: 0;





											}
										}

										/* mobile text align */
										@media (max-width: 767px) {
											
										}
									</style>



									<div kjb-settings-id="sections_1615856956840_blocks_1615857321001_settings_width"
										id="block-1615857321001" class="
  block-type--image
  text-
  col-4
  
  
  
    
  
  " data-reveal-event="" data-reveal-offset="" data-reveal-units="seconds">
										<div class="block
    box-shadow-small
    " data-aos="none" data-aos-delay="0" data-aos-duration="0">

											<style>
												#block-1615857321001 .block {
													display: flex;
													justify-content: flex-start;
												}

												#block-1615857321001 .image {
													width: 100%;

												}

												#block-1615857321001 .image__image {
													width: 100%;

												}

												#block-1615857321001 .image__overlay {

													opacity: 0;

													background-color: #fff;
												}


												@media (min-width: 768px) {
													#block-1615857321001 .block {
														display: flex;
														justify-content: flex-start;
													}

													#block-1615857321001 .image__overlay {
														opacity: 0;
													}

													#block-1615857321001 .image__overlay:hover {
														opacity: 1;
													}
												}
											</style>

											<div class="image">

												<a>
													<h4>Predication/mind map</h4>

												</a>



											</div>

										</div>
									</div>



									<!-- removes default padding from card elements -->

									<!-- removes default padding when box-shadow is enabled -->

									<!-- default padding values -->



									<style>
										/* flush setting */

										/* margin settings */
										#block-1615857415690 {
											margin-top: 0px;
											margin-right: 0px;
											margin-bottom: 0px;
											margin-left: 0px;
										}

										#block-1615857415690 .block {
											/* border settings */
											border: 4px none black;
											border-radius: 4px;
											/* background color */

											/* default padding for mobile */





											/* mobile padding overrides */

											padding: 0;





										}

										@media (min-width: 768px) {

											/* desktop margin settings */
											#block-1615857415690 {
												margin-top: 0px;
												margin-right: 0px;
												margin-bottom: 0px;
												margin-left: 0px;
											}

											#block-1615857415690 .block {
												/* default padding for desktop  */




												/* desktop padding overrides */

												padding: 0;





											}
										}

										/* mobile text align */
										@media (max-width: 767px) {
											
										}
									</style>



									<div kjb-settings-id="sections_1615856956840_blocks_1615857415690_settings_width"
										id="block-1615857415690" class="
  block-type--image
  text-
  col-4
  
  
  
    
  
  " data-reveal-event="" data-reveal-offset="" data-reveal-units="seconds">
										<div class="block
    box-shadow-small
    " data-aos="none" data-aos-delay="0" data-aos-duration="0">

											<style>
												#block-1615857415690 .block {
													display: flex;
													justify-content: flex-start;
												}

												#block-1615857415690 .image {
													width: 100%;

												}

												#block-1615857415690 .image__image {
													width: 100%;

												}

												#block-1615857415690 .image__overlay {

													opacity: 0;

													background-color: #fff;
												}


												@media (min-width: 768px) {
													#block-1615857415690 .block {
														display: flex;
														justify-content: flex-start;
													}

													#block-1615857415690 .image__overlay {
														opacity: 0;
													}

													#block-1615857415690 .image__overlay:hover {
														opacity: 1;
													}
												}
											</style>

											<div class="image">
												<a>
													<h4>Regular webinars/ seminars</h4>

												</a>



											</div>

										</div>
									</div>



									<!-- removes default padding from card elements -->

									<!-- removes default padding when box-shadow is enabled -->

									<!-- default padding values -->



									<style>
										/* flush setting */

										/* margin settings */
										#block-1615857847451 {
											margin-top: 0px;
											margin-right: 0px;
											margin-bottom: 0px;
											margin-left: 0px;
										}

										#block-1615857847451 .block {
											/* border settings */
											border: 4px none black;
											border-radius: 4px;
											/* background color */

											/* default padding for mobile */





											/* mobile padding overrides */

											padding: 0;





										}

										@media (min-width: 768px) {

											/* desktop margin settings */
											#block-1615857847451 {
												margin-top: 0px;
												margin-right: 0px;
												margin-bottom: 0px;
												margin-left: 0px;
											}

											#block-1615857847451 .block {
												/* default padding for desktop  */




												/* desktop padding overrides */

												padding: 0;





											}
										}

										/* mobile text align */
										@media (max-width: 767px) {
											
										}
									</style>



									<div kjb-settings-id="sections_1615856956840_blocks_1615857847451_settings_width"
										id="block-1615857847451" class="
  block-type--image
  text-
  col-4
  
  
  
    
  
  " data-reveal-event="" data-reveal-offset="" data-reveal-units="seconds">
										<div class="block
    box-shadow-small
    " data-aos="none" data-aos-delay="0" data-aos-duration="0">

											<style>
												#block-1615857847451 .block {
													display: flex;
													justify-content: flex-start;
												}

												#block-1615857847451 .image {
													width: 100%;

												}

												#block-1615857847451 .image__image {
													width: 100%;

												}

												#block-1615857847451 .image__overlay {

													opacity: 0;

													background-color: #fff;
												}

												@media (min-width: 768px) {
													#block-1615857847451 .block {
														display: flex;
														justify-content: flex-start;
													}

													#block-1615857847451 .image__overlay {
														opacity: 0;
													}

													#block-1615857847451 .image__overlay:hover {
														opacity: 1;
													}
												}
											</style>

											<div class="image">

												<a>
													<h4>Free value add services/samples</h4>

												</a>



											</div>

										</div>
									</div>



									<!-- removes default padding from card elements -->

									<!-- removes default padding when box-shadow is enabled -->

									<!-- default padding values -->



									<style>
										/* flush setting */

										/* margin settings */
										#block-1615857871057 {
											margin-top: 0px;
											margin-right: 0px;
											margin-bottom: 0px;
											margin-left: 0px;
										}

										#block-1615857871057 .block {
											/* border settings */
											border: 4px none black;
											border-radius: 4px;
											/* background color */

											/* default padding for mobile */





											/* mobile padding overrides */

											padding: 0;





										}

										@media (min-width: 768px) {

											/* desktop margin settings */
											#block-1615857871057 {
												margin-top: 0px;
												margin-right: 0px;
												margin-bottom: 0px;
												margin-left: 0px;
											}

											#block-1615857871057 .block {
												/* default padding for desktop  */




												/* desktop padding overrides */

												padding: 0;





											}
										}

										/* mobile text align */
										@media (max-width: 767px) {
											
										}
									</style>



									<div kjb-settings-id="sections_1615856956840_blocks_1615857871057_settings_width"
										id="block-1615857871057" class="
  block-type--image
  text-
  col-4
  
  
  
    
  
  " data-reveal-event="" data-reveal-offset="" data-reveal-units="seconds">
										<div class="block
    box-shadow-small
    " data-aos="none" data-aos-delay="0" data-aos-duration="0">

											<style>
												#block-1615857871057 .block {
													display: flex;
													justify-content: flex-start;
												}

												#block-1615857871057 .image {
													width: 100%;

												}

												#block-1615857871057 .image__image {
													width: 100%;

												}

												#block-1615857871057 .image__overlay {

													opacity: 0;

													background-color: #fff;
												}

												
												@media (min-width: 768px) {
													#block-1615857871057 .block {
														display: flex;
														justify-content: flex-start;
													}

													#block-1615857871057 .image__overlay {
														opacity: 0;
													}

													#block-1615857871057 .image__overlay:hover {
														opacity: 1;
													}
													
												}
											</style>

											<div class="image">

												<a>
													<h4 >Use Our Online tools: calculators(stress/mental stages/ Pressure) Know stage of you mental health</h4>

												</a>



											</div>

										</div>
									</div>



								</div>
							</div>
						</div>
					</section>
				</div>
				<div id="section-1615865896997" data-section-id="1615865896997">
					<style>
						.image>h4{
														font-weight: 400;
													}
						

						#section-1615865896997 .sizer {
							padding-top: 40px;
							padding-bottom: 40px;
						}

						#section-1615865896997 .container {
							max-width: calc(1260px + 10px + 10px);
							padding-right: 10px;
							padding-left: 10px;

						}

						#section-1615865896997 .container--full {
							max-width: calc(100% + 10px + 10px);
						}

						@media (min-width: 768px) {

							#section-1615865896997 .sizer {
								padding-top: 0px;
								padding-bottom: 100px;
							}

							#section-1615865896997 .container {
								max-width: calc(1260px + 40px + 40px);
								padding-right: 40px;
								padding-left: 40px;
							}

							#section-1615865896997 .container--full {
								max-width: calc(100% + 40px + 40px);
							}
						}
					</style>


				</div>
			</div>
		</main>
		<div id="section-footer" data-section-id="footer">
			<style>
				.footer,
				.footer__block {
					font-size: 16px;
					color: white ;
				}

				.footer .logo__text {
					color: white;
				}

				.footer .link-list__links {
					width: 100%;
				}


				@media (min-width: 768px) {

					.footer,
					.footer__block {
						font-size: 18px;
					}
				}


				.footer__content{
					background:#786a68;
				}
			</style>

			<footer class="footer    " kjb-settings-id="sections_footer_settings_background_color">
				<div class="footer__content">
					<div class="container footer__container media">


						<div id="block-1555988519593" class="footer__block ">
							<style>
								#block-1555988519593 {
									line-height: 1;
								}

								#block-1555988519593 .logo__image {
									display: block;
									width: 220px;
								}
							</style>

							<!-- <a class="logo" href="/">


								<img class="logo__image" src="WhatsApp Image 2021-03-18 at 15.52.55.jpeg"
									alt="Footer Logo" />


							</a> -->
							<ul class="footer-links list-reset" style="display: flex; color:white !important;">
								<li style="margin: 0 15px; ">
									<a style="color:white !important;" href="tel:+91 8595591496">Contact</a>
								</li>
								<li style="margin: 0 15px;">
									<a style="color:white !important;"  href="https://www.instagram.com/nowcare4u/?hl=en">Instagram</a>
								</li>
								<li style="margin: 0 15px;">
									<a style="color:white !important;" href="https://twitter.com/nowcare4u?lang=en">Twitter</a>
								</li>
								<li style="margin: 0 15px;">
									<a style="color:white !important;" href="https://www.facebook.com/nowcare4u/">Facebook</a>
								</li>
								<li style="margin: 0 15px;">
									<a style="color:white !important;" href="https://www.linkedin.com/company/nowcare4u/">LinkedIn</a>
								</li>
							</ul>

						</div>




						<div id="block-1555988525205" class="footer__block ">
							<span class="copyright"
								kjb-settings-id="sections_footer_blocks_1555988525205_settings_copyright">
								<a href="/">&copy; NowCare4U</a>
							</span>

						</div>



					</div>
				</div>
			</footer>

		</div>

		<div id="section-two_step" data-section-id="two_step">
			<style>
			</style>

			<div class="modal two-step" id="two-step" kjb-settings-id="sections_two_step_settings_two_step_edit">
				<div class="modal__content background-unrecognized">
					<div class="modal__body row text- align-items-start justify-content-left">


						<!-- removes default padding from card elements -->

						<!-- removes default padding when box-shadow is enabled -->

						<!-- default padding values -->



						<style>
							/* flush setting */

							/* margin settings */
							#block-1585757540189 {
								margin-top: 0px;
								margin-right: 0px;
								margin-bottom: 0px;
								margin-left: 0px;
							}

							#block-1585757540189 .block {
								/* border settings */
								border: 4px none black;
								border-radius: 4px;
								/* background color */

								/* default padding for mobile */



								/* mobile padding overrides */

								padding: 0;





							}

							@media (min-width: 768px) {

								/* desktop margin settings */
								#block-1585757540189 {
									margin-top: 0px;
									margin-right: 0px;
									margin-bottom: 0px;
									margin-left: 0px;
								}

								#block-1585757540189 .block {
									/* default padding for desktop  */


									/* desktop padding overrides */

									padding: 0;





								}
							}

							/* mobile text align */
							@media (max-width: 767px) {
								
							}
						</style>



						<div kjb-settings-id="sections_two_step_blocks_1585757540189_settings_width"
							id="block-1585757540189" class="
  block-type--image
  text-
  col-12
  
  
  
  " data-reveal-event="" data-reveal-offset="" data-reveal-units="">
							<div class="block
    box-shadow-none
    " data-aos="-" data-aos-delay="" data-aos-duration="">

								<style>
									#block-1585757540189 .block {
										display: flex;
										justify-content: flex-start;
									}

									#block-1585757540189 .image {
										width: 100%;

									}

									#block-1585757540189 .image__image {
										width: 100%;

									}

									#block-1585757540189 .image__overlay {

										opacity: 0;

										background-color: #fff;
									}


									@media (min-width: 768px) {
										#block-1585757540189 .block {
											display: flex;
											justify-content: flex-start;
										}

										#block-1585757540189 .image__overlay {
											opacity: 0;
										}

										#block-1585757540189 .image__overlay:hover {
											opacity: 1;
										}
									}
								</style>

								<div class="image">


									<img class="image__image"
										src="https://kajabi-storefronts-production.global.ssl.fastly.net/kajabi-storefronts-production/themes/2147493283/assets/placeholder.png?1615935203353986"
										kjb-settings-id="sections_two_step_blocks_1585757540189_settings_image"
										alt="" />



								</div>

							</div>
						</div>





						<!-- removes default padding from card elements -->

						<!-- removes default padding when box-shadow is enabled -->

						<!-- default padding values -->



						<style>
							/* flush setting */

							/* margin settings */
							#block-1585757543890 {
								margin-top: 0px;
								margin-right: 0px;
								margin-bottom: 0px;
								margin-left: 0px;
							}

							#block-1585757543890 .block {
								/* border settings */
								border: 4px none black;
								border-radius: 4px;
								/* background color */

								/* default padding for mobile */



								/* mobile padding overrides */





							}

							@media (min-width: 768px) {

								/* desktop margin settings */
								#block-1585757543890 {
									margin-top: 0px;
									margin-right: 0px;
									margin-bottom: 0px;
									margin-left: 0px;
								}
							}

							/* mobile text align */
							@media (max-width: 767px) {
								#block-1585757543890 {
									text-align: center;
								}
							}
						</style>



						<div kjb-settings-id="sections_two_step_blocks_1585757543890_settings_width"
							id="block-1585757543890" class="
  block-type--form
  text-center
  col-12
  
  
  
  " data-reveal-event="" data-reveal-offset="" data-reveal-units="">
							<div class="block
    box-shadow-none
    " data-aos="-" data-aos-delay="" data-aos-duration="">
								<style>
									#block-1585757543890 .form-btn {
										border-color: #f50057;
										border-radius: 12px;
										background: #f50057;
										color: #ffffff;
									}

									#block-1585757543890 .btn--outline {
										color: #f50057;
										background: transparent;
									}

									#block-1585757543890 .disclaimer-text {
										font-size: 16px;
										margin-top: 1.25rem;
										margin-bottom: 0;
										color: #888;
									}
								</style>



								<div class="form">
									<div kjb-settings-id="sections_two_step_blocks_1585757543890_settings_text">
										<h4>Join Our Free Trial</h4>
										<p>Get started today before this once in a lifetime opportunity expires.</p>
									</div>



								</div>

							</div>
						</div>




					</div>
				</div>
			</div>



		</div>
		<!-- Javascripts ======================================================= -->
		<script charset='ISO-8859-1' src='https://fast.wistia.com/assets/external/E-v1.js'></script>
		<script charset='ISO-8859-1' src='https://fast.wistia.com/labs/crop-fill/plugin.js'></script>
		<script
			src="https://kajabi-app-assets.global.ssl.fastly.net/assets/encore_core-55b3c981edaebd9d4962042e878b8c9f26f85663225787b06cd7475243170494.js"></script>
		<script
			src="https://kajabi-storefronts-production.global.ssl.fastly.net/kajabi-storefronts-production/themes/2147493283/assets/scripts.js?1615935203353986"></script>



		<!-- Customer JS ======================================================= -->
		<script>
			/* Custom JS Added Via Theme Settings */
			/* Javascript code goes here */
		</script>


	</body>

</html>